import { type GoogleIntegrationView } from "./googleIntegration";
import { type LineLinkSnapshot } from "./lineLink";

export const UI_TEXT_TONE = {
  eyebrow: "text-[#A67C52]",
  title: "text-[#7C5A4E]",
  body: "text-[#6B5851]",
  bodyMuted: "text-[#7A655C]",
  sectionTitle: "text-[#6A4F44]",
  meta: "text-[#8E776C]",
  success: "text-[#58705A]",
  warning: "text-[#A46D4C]",
  error: "text-[#A1493E]",
} as const;

const STATUS_BADGE_CLASS = {
  neutral: "border-[#E4D5C8] bg-[#FFF8F4] text-[#7C5A4E]",
  warning: "border-[#E6DACD] bg-[#FFF8F1] text-[#A46D4C]",
  success: "border-[#D8E7D3] bg-[#F7FBF3] text-[#5F8B57]",
  error: "border-[#E8B2A8] bg-[#FFF3F1] text-[#A1493E]",
} as const;

export function getGoogleStatusBadgeClass(status: GoogleIntegrationView) {
  switch (status.state) {
    case "connected":
      return STATUS_BADGE_CLASS.success;
    case "loading":
      return STATUS_BADGE_CLASS.warning;
    case "scope_missing":
    case "error":
      return STATUS_BADGE_CLASS.error;
    default:
      return STATUS_BADGE_CLASS.neutral;
  }
}

export function getLineStatusBadgeClass(snapshot: LineLinkSnapshot) {
  switch (snapshot.status) {
    case "linked":
      return STATUS_BADGE_CLASS.success;
    case "pending":
      return STATUS_BADGE_CLASS.warning;
    case "error":
      return STATUS_BADGE_CLASS.error;
    default:
      return STATUS_BADGE_CLASS.neutral;
  }
}
